/**
 * 管理后台用户接口
 * 管理后台用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import AccountDailyRiskStatVo from './AccountDailyRiskStatVo';
import JwStudentVo from './JwStudentVo';
import RoleVo from './RoleVo';




  /**
   * The AccountVo model module.
   * @module account_mgt/model/AccountVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>AccountVo</code>.
   * @alias module:account_mgt/model/AccountVo
   * @class
   */
  var exports = function() {
    var _this = this;














  };

  /**
   * Constructs a <code>AccountVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:account_mgt/model/AccountVo} obj Optional instance to populate.
   * @return {module:account_mgt/model/AccountVo} The populated <code>AccountVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'phoneNum')) {
        obj['phoneNum'] = ApiClient.convertToType(data['phoneNum'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'idNumber')) {
        obj['idNumber'] = ApiClient.convertToType(data['idNumber'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'code')) {
        obj['code'] = ApiClient.convertToType(data['code'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtCreate')) {
        obj['gmtCreate'] = ApiClient.convertToType(data['gmtCreate'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtModified')) {
        obj['gmtModified'] = ApiClient.convertToType(data['gmtModified'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'jwStudentList')) {
        obj['jwStudentList'] = ApiClient.convertToType(data['jwStudentList'], [JwStudentVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'redeemTextBookCount')) {
        obj['redeemTextBookCount'] = ApiClient.convertToType(data['redeemTextBookCount'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'frozen')) {
        obj['frozen'] = ApiClient.convertToType(data['frozen'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'roleList')) {
        obj['roleList'] = ApiClient.convertToType(data['roleList'], [RoleVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'dailyRiskStat')) {
        obj['dailyRiskStat'] = AccountDailyRiskStatVo.constructFromObject(data['dailyRiskStat']);
      }
    }
    return obj;
  }

  /**
   * 账号ID
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 0学生1老师
   * @member {Integer} type
   */
  exports.prototype['type'] = undefined;
  /**
   * 姓名
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 手机号
   * @member {String} phoneNum
   */
  exports.prototype['phoneNum'] = undefined;
  /**
   * 身份证号
   * @member {String} idNumber
   */
  exports.prototype['idNumber'] = undefined;
  /**
   * 工号
   * @member {String} code
   */
  exports.prototype['code'] = undefined;
  /**
   * 创建时间
   * @member {Date} gmtCreate
   */
  exports.prototype['gmtCreate'] = undefined;
  /**
   * 修改时间
   * @member {Date} gmtModified
   */
  exports.prototype['gmtModified'] = undefined;
  /**
   * 学生学籍信息列表
   * @member {Array.<module:account_mgt/model/JwStudentVo>} jwStudentList
   */
  exports.prototype['jwStudentList'] = undefined;
  /**
   * 兑换教材册数
   * @member {Integer} redeemTextBookCount
   */
  exports.prototype['redeemTextBookCount'] = undefined;
  /**
   * 当前是否冻结 true:冻结 false:未冻结
   * @member {Boolean} frozen
   */
  exports.prototype['frozen'] = undefined;
  /**
   * @member {Array.<module:account_mgt/model/RoleVo>} roleList
   */
  exports.prototype['roleList'] = undefined;
  /**
   * 每日学习数据风控统计
   * @member {module:account_mgt/model/AccountDailyRiskStatVo} dailyRiskStat
   */
  exports.prototype['dailyRiskStat'] = undefined;



  export default exports;
;


